import styled from '@emotion/styled';

import { forMobile, Typography } from '@/shared/design-system';

export const SwitchAction = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
});

export const UnavailableAction = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: theme.spacing[8],

  [forMobile]: {
    alignItems: 'flex-end',
    flexDirection: 'column',
    gap: theme.spacing[4],
  },
}));

export const InlineError = styled(Typography)(({ theme }) => ({
  color: theme.colors.text.error,
  textWrap: 'pretty',
}));
